import { FeaturedVictories } from './components/FeaturedVictories';
import { VictoriesBody } from './components/VictoriesBody';
import { VictoryHighlight } from './components/VictoryHighlight';

export function VictoriesImpact() {
	return (
		<>
			<VictoriesBody />
			<VictoryHighlight />
			<FeaturedVictories />
		</>
	);
}
